import type { ProgressReport } from '@brighterly/lib-core-types/progress-report/interfaces'
import type { ProgressReportStore } from '@stores/progress-report/interfaces'

import { useDisciplineStore } from '@stores/discipline'

export const getReport = (state: ProgressReportStore): ProgressReport | null => {
  const disciplineStore = useDisciplineStore()

  return disciplineStore.isEla
    ? state.reportEla
    : disciplineStore.isMath
      ? state.reportMath
      : null
}

export const getReportTitle = (report: ProgressReport | null): string => {
  return report?.number
    ? `Progress Report #${report.number}`
    : 'Progress Report'
}

export const report = {
  getReport: (state: ProgressReportStore): ProgressReport | null => getReport(state),
  isReport: (state: ProgressReportStore): boolean => !!getReport(state),
  getNumber: (state: ProgressReportStore): ProgressReport['number'] | null => getReport(state)?.number ?? null,
  getTitle: (state: ProgressReportStore): string => getReportTitle(getReport(state)),
}
